import { render, staticRenderFns } from "./ChoiceItem.vue?vue&type=template&id=30e1dd99&scoped=true&"
import script from "./ChoiceItem.vue?vue&type=script&lang=js&"
export * from "./ChoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceItem.vue?vue&type=style&index=0&id=30e1dd99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e1dd99",
  null
  
)

export default component.exports